import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 31 4"
    {...props}
  >
    <path fill="#D8DAE5" d="M29 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4"></path>
    <path
      fill="#D9D9D9"
      fillRule="evenodd"
      d="M26 2H5z"
      clipRule="evenodd"
    ></path>
    <path stroke="#D8DAE5" strokeDasharray="4 4" d="M26 2H5"></path>
    <path fill="#D8DAE5" d="M2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4"></path>
  </svg>
);

export default SvgIcon;
